import { render, staticRenderFns } from "./ShopView.vue?vue&type=template&id=3846b582&scoped=true&"
import script from "./ShopView.vue?vue&type=script&lang=js&"
export * from "./ShopView.vue?vue&type=script&lang=js&"
import style0 from "./ShopView.vue?vue&type=style&index=0&id=3846b582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3846b582",
  null
  
)

export default component.exports